import { RolloutProgressReportEntities } from '../../../shared/self-inspection-reports/service/entities';
import {
  createPopupPdfContext,
  type PopupPdfDownloadContext,
  type PopupPdfPayload,
} from './popup-pdf-download.controller';
import { getIfsFromUrl } from './popup-pdf.utils';

export function createReportablePopupPdfContext(
  getRouterUrl: () => string,
  getDeliveryOrderId: () => string,
  getAddress: () => string,
  getLocale: () => string,
  getMarkerType: () => RolloutProgressReportEntities.v3.MarkerTypes,
  isDestroyed: () => boolean,
): PopupPdfDownloadContext {
  const getPayload = (): PopupPdfPayload | null => {
    const ifsNumber = getIfsFromUrl(getRouterUrl());
    const deliveryOrderId = getDeliveryOrderId();
    if (!ifsNumber || !deliveryOrderId) return null;
    return {
      ifsNumber,
      deliveryOrderId,
      locale: getLocale(),
      address: getAddress(),
      rolloutPointType: getMarkerType(),
    };
  };
  return createPopupPdfContext(getPayload, isDestroyed);
}
